import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { useConfig } from 'config/ConfigContext';

import {
  nextAction,
  checkPreviousAction,
} from 'actions/workflow';

import style from './style.scss';

const MicroBiltVerification = (props) => {
  const appConfig = useConfig();
  const workflow = useSelector((state) => state.workflow);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [microbiltHeight, setMicrobiltHeight] = useState(0);
  const microbiltContainerRef = useRef(null);
  const key = searchParams.get('key');

  const onMessageReceived = (event) => {
    const { data } = event;

    if (data.microbiltComplete) {
      if (key) {
        dispatch(nextAction({
          url: `/workflows/microbilt/${key}/next`,
          data: {},
          fail: (err) => {
            console.log(err);
          },
        }));
      }
    }
  };

  useEffect(() => {
    const sourceData = get(workflow, 'data', null) || get(workflow, 'data.data', null);
    if (!sourceData) {
      dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/microbilt/${key}/checkin`,
        success: (response) => {
          const routeUrl = get(response, 'data.url');
          navigate(routeUrl);
        },
        fail: () => {
          navigate('/fsl/application', { replace: true });
        },
      }));
    }

    if (microbiltHeight === 0) {
      setMicrobiltHeight(microbiltContainerRef.current.clientHeight - 50);
    }

    window.addEventListener('message', onMessageReceived, false);
    return () => {
      window.removeEventListener('message', onMessageReceived, false);
    };
  }, []);

  useEffect(() => {
    if (!workflow.isLoading) {
      if (get(workflow, 'data.data.nextAction.path') || get(workflow, 'state.data.nextAction.path')) {
        dispatch(nextAction({
          apiUrl: `${appConfig.apiUrl}/workflows${get(workflow, 'data.data.nextAction.path') || get(workflow, 'state.data.nextAction.path')}`,
          data: {},
        }));
      } else if (get(workflow, 'data.nextAction.path') || get(workflow, 'state.nextAction.path')) {
        dispatch(nextAction({
          apiUrl: `${appConfig.apiUrl}/workflows${get(workflow, 'data.nextAction.path') || get(workflow, 'state.nextAction.path')}`,
          data: {},
        }));
      } else if (get(workflow, 'data.url') || get(workflow, 'state.url')) {
        const url = get(workflow, 'data.url') || get(workflow, 'state.url');
        const routeUrl = url.replace(appConfig.hostUrl, '');
        navigate(routeUrl);
      }
    }
  }, [workflow]);

  const handleVerifyLater = () => {
    const { nextAction } = props;

    if (key) {
      dispatch(nextAction({
        url: `/workflows/microbilt/${key}/next`,
        data: {
          skip: true,
        },
        fail: (err) => {
          console.log(err);
        },
      }));
    }
  };

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section')}>
        <div className={style.microbiltCcontainer} ref={microbiltContainerRef}>
          <div className={style.verifyManual} onClick={handleVerifyLater}>Verify Manually</div>
          {
            (get(workflow, 'data', null) || get(workflow, 'state', null)) && (
              <iframe
                title="microbilt verification"
                src={`${get(workflow, 'data.data.microBiltUrl', '') || get(workflow, 'state.data.microBiltUrl', '')}`}
                width="100%"
                height={700}
                frameBorder="0"
                style={{ overflow: 'hidden' }}
              />
            )
          }
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default MicroBiltVerification;
